<script setup>
defineProps({
  modalActive: Boolean,
  videoUrl: String,
  youtubeUrl: String,
})
defineEmits(['close'])
</script>

<template>
  <transition
    enter-active-class="transition-opacity duration-300"
    enter-from-class="opacity opacity-0"
    enter-to-class="opacity opacity-100"
    leave-active-class="transition-opacity duration-200"
    leave-from-class="opacity opacity-100"
    leave-to-class="opacity opacity-0"
  >
    <div v-if="modalActive" class="relative z-[100]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="fixed inset-0 z-[100] overflow-y-auto">
        <div class="relative h-full flex items-center justify-center">
          <div class="z-10 w-full transform overflow-hidden rounded-none px-4 text-left shadow-xl transition-all sm:my-8 sm:max-w-6xl">
            <lite-youtube v-if="youtubeUrl" :url="youtubeUrl" />
            <video
              v-else-if="videoUrl"
              class="m-auto w-full rounded-xl object-cover transition duration-150 ease-out" autoplay controls playsinline preload="metadata"
            >
              <source :src="videoUrl" type="video/mp4">
            </video>
          </div>
          <div class="fixed inset-0 z-0 bg-[#0e0c1f] bg-opacity-50 backdrop-blur-[3px] transition-opacity" @click="$emit('close')" />
        </div>
      </div>
    </div>
  </transition>
</template>
